import React from "react";
import { Tree, TreeNode } from "react-organizational-chart";
import PropTypes from "prop-types";
import DeleteIcon from "../Icons/DeleteIcon";

const TeamTree = ({ data, onDelete }) => {
  // console.log("Data in TeamTree >>>>>>>>>>>>",data);
  const renderTree = (node) => {
    if (!node) return null;

    return (
      <TreeNode
        label={
          <div className="node-label d-flex gap-4 justify-content-center align-items-center">
            <span>
              {node.name} <span className="fs-5">{data?.name ? `(${node.designation})` : ""}</span>
            </span>
            {data?.name && <button className="btn p-0" onClick={() => onDelete(node)}>
              <DeleteIcon />
            </button>}
          </div>
        }
        key={node.id}
      >
        {node.childrens && node.childrens.map((child) => renderTree(child))}
      </TreeNode>
    );
  };

  return (
    <div className="team-tree">
      <Tree
        label={
          <div className="root-label d-flex gap-4 justify-content-center align-items-center">
            <span>
              {data?.name} <span className="fs-5">{data?.name ? `(${data.designation})` : ""}</span>
            </span>
            {data?.name && <button className="btn p-0" onClick={() => onDelete(data)}>
              <DeleteIcon />
            </button>}
          </div>
        }
        lineColor="#007BFF" // Custom line color for connections
      >
        {data?.childrens && data?.childrens.map((child) => renderTree(child))}
      </Tree>
    </div>
  );
};

TeamTree.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    designation: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        designation: PropTypes.string.isRequired,
        children: PropTypes.array,
      })
    ),
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default TeamTree;
